const titleCase = function(str) {
  if (!str) return "";
  let upper = true;
  let newStr = "";
  for (let i = 0, l = str.length; i < l; i++) {
    if (str[i].match(/\s/)) {
      upper = true;
      newStr += " ";
      continue;
    }
    newStr += upper ? str[i].toUpperCase() : str[i].toLowerCase();
    upper = false;
  }
  return newStr;
};

const parameterize = function(str) {
  return str.replace(/\s/g, "-").toLowerCase();
};

/**
 * Formats an image path for use with Cloudflare Image Delivery
 * Removes leading slash and file extensions (.jpg, .png, .jpeg)
 * @param {string} imagePath - The original image path
 * @returns {string} - The formatted image path for Cloudflare
 */
const formatImageKey = function(imagePath) {
  if (!imagePath) return "";
  return imagePath.replace(/^\//, '').replace(/\.jpg$|\.png$|\.jpeg$/i, '');
};

export { parameterize, titleCase, formatImageKey };
